import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import { useOffice } from '../contexts/OfficeContext'
import { supabase } from '../lib/supabase'

export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user, loading: authLoading } = useAuth()
  const { loading: officeLoading, onboardingCompleted, officeId, noOffice } = useOffice()
  const location = useLocation()

  if (authLoading || officeLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-950">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-brand border-t-transparent" />
      </div>
    )
  }

  if (!user) return <Navigate to="/login" replace />

  // User was previously active but access was revoked by an admin.
  // Show a clear blocking screen — do not redirect to onboarding or dashboard.
  if (noOffice) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center px-6"
        style={{ backgroundColor: 'var(--bg-page)' }}>
        <div className="w-full max-w-sm text-center">
          <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6"
            style={{ backgroundColor: 'rgba(239,68,68,0.10)' }}>
            <svg className="w-8 h-8 text-red-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
              <path strokeLinecap="round" strokeLinejoin="round"
                d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636" />
            </svg>
          </div>
          <h1 className="text-xl font-bold mb-2" style={{ color: 'var(--text-primary)' }}>
            Acesso revogado
          </h1>
          <p className="text-sm mb-6" style={{ color: 'var(--text-secondary)' }}>
            Sua conta não possui acesso a nenhum escritório. Entre em contato com o administrador para ser convidado novamente.
          </p>
          <button
            onClick={() => supabase.auth.signOut()}
            className="w-full rounded-xl px-4 py-3 text-sm font-semibold text-white transition hover:opacity-90"
            style={{ backgroundColor: '#1D9E75' }}
          >
            Sair da conta
          </button>
        </div>
      </div>
    )
  }

  // Redirect to onboarding only if user has no office yet or hasn't completed setup.
  // If they already have an officeId (invited member or admin mid-onboarding),
  // let them through — they're in an existing operational office.
  if (onboardingCompleted === false && !officeId && location.pathname !== '/onboarding') {
    return <Navigate to="/onboarding" replace />
  }

  return children
}
